import useAxios from 'axios-hooks'
import React from 'react'
import { useSelector } from 'react-redux'
import { brazilianStates } from '~/constants/location'

export const useFormFilters = ({ values }) => {
  const currentProjectId = useSelector(state => state.user?.selectedProject?.id)

  const allLocations =
    JSON.parse(localStorage.getItem('state'))?.allLocationsToogle !== undefined
      ? JSON.parse(localStorage.getItem('state'))?.allLocationsToogle
      : true

  const [{ data: filters, loading: filterLoading }] = useAxios({
    url: `/locations/filters`,
    method: 'GET',
    params: {
      project: allLocations ? undefined : currentProjectId,
    },
  })

  const filterStates = React.useMemo(() => {
    if (!filters) return []
    if (!values) return []

    const { states } = values
    return states.map(state => {
      return {
        value: [state],
        label: brazilianStates.find(item => item.uf === state)?.state,
      }
    })
  }, [filters, values])

  const filterCities = React.useMemo(() => {
    if (!filters) return []
    if (!values) return []

    const { cities } = values
    return cities.map(city => {
      return {
        value: [city],
        label: city,
      }
    })
  }, [filters, values])

  const filterAreas = React.useMemo(() => {
    if (!filters) return []
    if (!values) return []

    const { areas } = values
    return areas.map(area => {
      return {
        value: [area],
        label: area,
      }
    })
  }, [filters, values])

  const filterLabels = React.useMemo(() => {
    if (!filters) return []
    if (!values) return []

    const { labels } = values
    return labels.map(label => {
      return {
        value: [label],
        label: label,
      }
    })
  }, [filters, values])

  const filterLocations = React.useMemo(() => {
    if (!filters) return []
    if (!values) return []

    const { locations } = values
    return locations.map(location => {
      return {
        value: [location],
        label: location,
      }
    })
  }, [filters, values])

  function handleFilters(value, type, callback) {
    switch (type) {
      case 'state':
        const states = value.map(item => item.value[0])
        if (callback) {
          callback(states)
        }

        break
      case 'city':
        const cities = value.map(item => item.value[0])
        if (callback) {
          callback(cities)
        }

        break
      case 'area':
        const areas = value.map(item => item.value[0])
        if (callback) {
          callback(areas)
        }

        break
      case 'label':
        const labels = value.map(item => item.value[0])
        if (callback) {
          callback(labels)
        }

        break
      case 'location':
        const locations = value.map(item => item.value[0])
        if (callback) {
          callback(locations)
        }

        break
      default:
        break
    }
  }

  return {
    states: filterStates,
    cities: filterCities,
    areas: filterAreas,
    labels: filterLabels,
    locations: filterLocations,
    handleFilters,
    filterLoading,
    filters,
  }
}
